import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { AppConfig } from '../config';

let client: SupabaseClient | undefined;
let clientConfig: AppConfig | undefined;

/** One browser client per page load, created from the validated runtime config. */
export function initSupabase(config: AppConfig): SupabaseClient {
  client = createClient(config.supabaseUrl, config.supabaseAnonKey, {
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false },
  });
  clientConfig = config;
  return client;
}

export function supabase(): SupabaseClient {
  if (!client) throw new Error('Supabase client used before initSupabase()');
  return client;
}

export function appConfig(): AppConfig {
  if (!clientConfig) throw new Error('config used before initSupabase()');
  return clientConfig;
}
